import React from "react";
import { toast } from "sonner";
import { Copy } from "@phosphor-icons/react";
import { publicOrigin } from "@/lib/landerDomain";
import { BTN_WHITE } from "@/components/pageSettings/AdminModal";

export function PageLinks({ links, live }) {
  const origin = publicOrigin();
  const copy = (t) => { navigator.clipboard?.writeText(t); toast.success("Link copied"); };
  if (!links.length) return null;
  return (
    <div data-testid="setup-page-links">
      <div className="label-mono">Their page links on {origin.replace(/^https?:\/\//, "")}</div>
      {!live && <p className="text-[11px] text-amber-700 mt-1" data-testid="setup-links-not-live">These links start sending them leads once you go live.</p>}
      <ul className="mt-2 space-y-1">
        {links.map((l) => (
          <li key={`${l.kind}-${l.key}`} className="flex items-center gap-2" data-testid={`setup-link-${l.key}`}>
            <span className="text-[10px] uppercase tracking-widest w-24 sm:w-32 shrink-0 truncate" title={l.title}>{l.title}</span>
            <a href={`${origin}${l.path}`} target="_blank" rel="noreferrer"
               className="flex-1 min-w-0 border border-black bg-zinc-50 px-2 py-1 text-[10px] font-mono truncate hover:underline">{origin}{l.path}</a>
            {l.status && l.status !== "published" && <span className="label-mono text-zinc-500">Draft</span>}
            <button type="button" className={BTN_WHITE} onClick={() => copy(`${origin}${l.path}`)} aria-label="Copy link" data-testid={`setup-link-copy-${l.key}`}>
              <Copy size={10} weight="bold" />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
